<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <span class="cf-icon cf-icon--large cf-icon--red far fa-exclamation-circle" />

    <h1 class="cf-title cf-title--1">
      No location selected.
    </h1>

    <p class="cf-subtitle cf-subtitle--2">
      Please select a location to start adding items to your cart.
    </p>

    <button
      class="cf-button cf-button--primary cf-button--lg"
      type="button"
      @click="selectLocationClickHandler"
    >
      Select Location
    </button>
  </div>
</template>


<script>
  export default {
    name: 'NoSelectedLocation',

    methods: {
      selectLocationClickHandler() {
        this.$closeModal('no-selected-location-modal');

        this.$openModal('editOrderDetails');
      }
    }
  };
</script>
